// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"ECommerceSearchNotFound_componentStyle__qSHId","description":"ECommerceSearchNotFound_description__a8owc"};